import React from "react";
import ModalPopup from "../../../components/newcomponents/ModalPopup";
import { PlaybackLoader } from "./playbackLoader";
export const GlobalLoader = () => {
   return (
      <ModalPopup onModalTapped={() => { }}>
         <PlaybackLoader />
      </ModalPopup>
   );
};
